import { IApplicationData } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../../../queries/useApplicationCache';

/**
 * Reads the properties object from the React Query application cache.
 * Used by PropertyAddress for duplicate address validation.
 */
export function useApplicationPropertiesCache(): IApplicationData['information']['properties'] {
    return useApplicationCache(d => d.information?.properties);
}
